module.exports = __webpack_public_path__ + "media/src/assets/Images/menu-7c42812e1394ee2db225cfba73f52365.svg";